import * as React from "react"
import { useTranslation } from "react-i18next"
import "./CrsTogglebutton.css"

export interface ProjectSettingGroupProps {
  name: string
  projectSettings: ProjectSettingProps[]
  onClick?: React.MouseEventHandler // For testing setting the value
  optional?: boolean
  mismatch?: boolean
  message?: string
  hasButton?: boolean
  projectedCoordinates?: string
}

export const ProjectSettingGroup = (props: ProjectSettingGroupProps) => {
  const { projectSettings, optional, mismatch, message, hasButton, projectedCoordinates } = props
  const { t } = useTranslation("config")
  const [active, setActive] = React.useState("projected_crs")

  const handleClickGeo = () => {
    setActive("geo_crs")
  }
  const handleClickProjected = () => {
    setActive("projected_crs")
  }
  return (
    <div className="row mb-2">
      <div className="col-12 d-flex justify-content-between">
        <h5>{props.name}</h5>
        {hasButton && (
          <div className="toggle-div ">
            <button
              type="button"
              className={`${active === "geo_crs" ? "togglebuttonactive" : "btn"}`}
              onClick={handleClickGeo}
            >
              <span className="tooltip">
                (φ,λ)<span className="tooltiptext"> {t("connectSettings.geographic_toggle_tooltip")}</span>
              </span>
            </button>

            <button
              type="button"
              className={`${active === "projected_crs" ? "togglebuttonactive" : "btn"}`}
              onClick={handleClickProjected}
            >
              <span className="tooltip">
                (E,N)<span className="tooltiptext"> {t("connectSettings.projected_toggle_tooltoop")}</span>
              </span>
            </button>
          </div>
        )}
      </div>
      <div className="col-12">
        <hr className="my-1" />
      </div>

      {mismatch ? (
        <div className="col-12 mb-1">
          <div className="alert warning py-2">{message}</div>
        </div>
      ) : projectSettings.find((x) => x.value !== undefined) ? (
        projectSettings.map((x) => (
          <ProjectSetting
            key={x.name}
            {...x}
            hasbutton={hasButton}
            active={active}
            projectedCoordinates={projectedCoordinates}
          />
        ))
      ) : optional ? (
        <div className="col-12 mb-1">
          <div className="alert info py-2">{message}</div>
        </div>
      ) : (
        <div className="col-12 mb-1">
          <div className="alert error py-2">{message}</div>
        </div>
      )}
    </div>
  )
}

interface ProjectSettingProps {
  name: string
  value?: string
  hasbutton?: boolean
  active?: string
  projectedCoordinates?: string
  projectedCoordinatesIsLoading?: boolean
}

const ProjectSetting = (props: ProjectSettingProps) => {
  const { t } = useTranslation("config")
  return (
    <div className="col-12 mb-1" key={props.name}>
      {props.active === "projected_crs" && props.hasbutton ? (
        <div className="col-12 mb-1" key={props.name}>
          <small className="text-meta">{props.name}</small>
          {props.projectedCoordinates ? (
            <p>{props.projectedCoordinates}</p>
          ) : (
            <p>{t("connectSettings.coordinate_conversion_error")}</p> //In case of error
          )}
        </div>
      ) : (
        <div className="col-12 mb-1" key={props.name}>
          <small className="text-meta">{props.name}</small>
          <p>{props.value}</p>
        </div>
      )}
    </div>
  )
}
